import React from 'react';

import { ButtonGroup } from '../../ButtonGroup/ButtonGroup';
import { IconDollarSign } from '../../icons/IconDollarSign';
import { IconBroadcast } from '../../icons/IconBroadcast';

interface Props {
    disabled?: boolean;
    handleChange?(): void;
}

export const RoyaltiesVsPerformancesToggle = ({
    disabled = false,
    handleChange,
}: Props): JSX.Element => (
    <ButtonGroup
        disabled={disabled}
        options={[
            {
                value: 'earnings',
                label: (
                    <>
                        <IconDollarSign
                            addClasses="inline"
                            width={22}
                            fillColor="primary-100"
                        />
                        Royalties
                    </>
                ),
            },
            {
                value: 'plays',
                label: (
                    <>
                        <IconBroadcast
                            width={22}
                            addClasses="inline mr-1 mb-1"
                            fillColor="primary-500"
                        />
                        Performances
                    </>
                ),
            },
        ]}
        buttonsPerRow={2}
        handleChange={handleChange}
    />
);
